import type { IFilters } from '../shared/filters'

/** FE-only: BE is unit-agnostic */
export enum PricingUnit {
  Dollars,
  Percentage,
}

/** FE-only: BE is unit-agnostic */
export interface PricingLine {
  unit: PricingUnit
  percentageValue?: number
  dollarValue?: number
}

export interface IPricingFormCommon {
  miner_model_family: string
  wholesale_base_cost: number
}

export interface IPricingFormAdders {
  modular_facility_type_adder: number
  traditional_facility_type_adder: number
  immersion_cooling_type_adder: number
  water_cooling_type_adder: number
  air_cooling_type_adder: number
  third_party_firmware_adder: number
  overclocking_adder: number
}

export interface IPricingFormPartCosts {
  fan_basic_repair_cost: number
  fan_replacement_cost: number
  power_supply_basic_repair_cost: number
  power_supply_advanced_repair_cost: number
  power_supply_replacement_cost: number
  control_board_basic_repair_cost: number
  control_board_advanced_repair_cost: number
  control_board_replacement_cost: number
  hashboard_basic_repair_cost: number
  hashboard_advanced_repair_cost: number
  hashboard_replacement_cost: number
}

export interface IPricingFormAdditionalCosts {
  fan_labor_cost: number
  fan_shipping_cost: number
  power_supply_labor_cost: number
  power_supply_shipping_cost: number
  control_board_labor_cost: number
  control_board_shipping_cost: number
  hashboard_labor_cost: number
  hashboard_shipping_cost: number
}

// POST /pricings payload
export type ICreateMinerFamilyPricingForm = IPricingFormCommon & IPricingFormAdders & IPricingFormPartCosts

// GET /customers/pricing[s] response
export interface ICustomerMinerFamilyPricing {
  miner_model_family: string
  miner_model_family_abbreviation: string
  wholesale_base_cost: number
}

// GET /pricing[s] response
export interface IMinerModelFamilyPricing {
  id?: number
  miner_model_family: string
  miner_model_family_abbreviation: string
  wholesale_base_cost: number
  modular_facility_type_adder: number
  traditional_facility_type_adder: number
  immersion_cooling_type_adder: number
  water_cooling_type_adder: number
  air_cooling_type_adder: number
  third_party_firmware_adder: number
  overclocking_adder: number
  repair_costs: {
    fan_basic_repair_cost: number
    fan_replacement_cost: number
    power_supply_basic_repair_cost: number
    power_supply_advanced_repair_cost: number
    power_supply_replacement_cost: number
    control_board_basic_repair_cost: number
    control_board_advanced_repair_cost: number
    control_board_replacement_cost: number
    hashboard_basic_repair_cost: number
    hashboard_advanced_repair_cost: number
    hashboard_replacement_cost: number
  } | null
  additional_costs: {
    fan_labor_cost: number
    fan_shipping_cost: number
    power_supply_labor_cost: number
    power_supply_shipping_cost: number
    control_board_labor_cost: number
    control_board_shipping_cost: number
    hashboard_labor_cost: number
    hashboard_shipping_cost: number
  } | null
}

// GET /pricings params
export interface IMinerFamilyPricingFilters extends IFilters {
  miner_model_family?: string
}

// GET /pricings/:id/history response
export interface IMinerModelFamilyPricingHistory {
  miner_model_family: string
  action: string
  action_user: string
  action_timestamp: Date
}

// GET /pricings/:id/history params
export interface IMinerFamilyPricingHistoryFilters extends IFilters {
  start_date?: string
  end_date?: string
}
